import React, { useEffect } from 'react';

const LogoutCallback = () => {  
  useEffect(() => {
    window.location.href = window.location.origin;
  }, []);

  return (
      <div>
          <h1>User Logout Page</h1>
          <div>AWS will redirect to here automatically after logout</div>
          <br/>
          <div>you can relocate to login page if you prefer</div>
          <button id="demoAgain">go to demo home again</button>
      </div>
  );
};

export default LogoutCallback;
